import api from "./api";
import { NOTIFICATION_API_ENDPOINTS } from "../constants/notification.constant";

const BASE_URL = process.env.REACT_APP_PUSH_API_BASE || "/push/notifications";

export const getKpis = async (filters = {}) => {
  return api.get(
    `${BASE_URL}${NOTIFICATION_API_ENDPOINTS.GET_ANALYTICS_KPIS}`,
    {
      params: filters,
    }
  );
};

export const getChartData = async (params) => {
  // API expects groupBy and range parameters
  return api.get(
    `${BASE_URL}${NOTIFICATION_API_ENDPOINTS.GET_ANALYTICS_CHART}`,
    {
      params,
    }
  );
};

// Internal trigger functions (admin only)
export const triggerInstallmentNotification = async (customerId) => {
  return api.post(
    `${BASE_URL}${NOTIFICATION_API_ENDPOINTS.TRIGGER_INSTALLMENT}`,
    {
      customerId,
    }
  );
};

// Helper functions for data formatting
export const formatPercentage = (value) => {
  if (value === null || value === undefined) return "0%";
  return `${(value * 100).toFixed(1)}%`;
};

export const formatNumber = (value) => {
  if (value === null || value === undefined) return "0";
  return new Intl.NumberFormat().format(value);
};

export const getDateRangePresets = () => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  return {
    today: {
      label: "Today",
      start: today,
      end: now,
      range: "1d",
    },
    yesterday: {
      label: "Yesterday",
      start: new Date(today.getTime() - 24 * 60 * 60 * 1000),
      end: new Date(today.getTime() - 1),
      range: "1d",
    },
    last7Days: {
      label: "Last 7 Days",
      start: new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000),
      end: now,
      range: "7d",
    },
    last30Days: {
      label: "Last 30 Days",
      start: new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000),
      end: now,
      range: "30d",
    },
    thisMonth: {
      label: "This Month",
      start: new Date(now.getFullYear(), now.getMonth(), 1),
      end: now,
      range: "1m",
    },
    lastMonth: {
      label: "Last Month",
      start: new Date(now.getFullYear(), now.getMonth() - 1, 1),
      end: new Date(now.getFullYear(), now.getMonth(), 0),
      range: "1m",
    },
  };
};

// Chart groupBy options based on API
export const getGroupByOptions = () => [
  { value: "template", label: "By Template" },
  { value: "channel", label: "By Channel" },
  { value: "hour", label: "By Hour" },
];
